import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { getRouteUrl, routeConfigs } from '../common/constants/route.config';
import { AuthService } from '../common/services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router) {
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (!AuthService.authorized) {
            this.router.navigateByUrl(getRouteUrl(routeConfigs.auth.login));

            return false;
        }

        return true;
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/guards/auth.guard.ts